export default __webpack_public_path__ + "fonts/Inter-SemiBold.woff";